const NAME = 'windshieldRepairabilityProfiles';

const DRIVER_FIELD_OF_VIEW_LOCATION = {
  RIGHT: 0,
  LEFT: 1,
  CENTER: 2
};

const DRIVER_FIELD_OF_VIEW_LOCATION_NAME = {
  [DRIVER_FIELD_OF_VIEW_LOCATION.RIGHT]: 'Right',
  [DRIVER_FIELD_OF_VIEW_LOCATION.LEFT]: 'Left',
  [DRIVER_FIELD_OF_VIEW_LOCATION.CENTER]: 'Center'
};

const DRIVER_FIELD_OF_VIEW = {
  OFF: 0,
  WARNING: 1,
  BLOCKER: 2
};

const DRIVER_FIELD_OF_VIEW_NAME = {
  [DRIVER_FIELD_OF_VIEW.OFF]: 'Off',
  [DRIVER_FIELD_OF_VIEW.WARNING]: 'Warning',
  [DRIVER_FIELD_OF_VIEW.BLOCKER]: 'Blocker'
};

// Default settings for ADAS non-repairable area
// Distances measured in % from windshield segment's top edge center point
const DEFAULT_ADAS_FOV = [
  // TopLeft
  { x: -22, y: 0 },
  // TopRight
  { x: 22, y: 0 },
  // BottomRight
  { x: 22, y: 18 },
  // BottomLeft
  { x: -22, y: 18 },
];

// Default settings for left-sided drivers' (US, Europe, most of the world) field-of-view non-repairable area
// Distances measured in % from windshield segment's top right corner
const DEFAULT_DRIVER_FOV_LEFT = [
  // TopLeft
  { x: -35, y: 20 },
  // TopRight
  { x: 0, y: 20 },
  // BottomRight
  { x: 5, y: 79 },
  // BottomLeft
  { x: -22, y: 83 },
];

// Default settings for right-sided drivers' (UK, Australia etc) field-of-view non-repairable area
// Distances measured in % from windshield segment's top left corner
const DEFAULT_DRIVER_FOV_RIGHT = [
  // TopLeft
  { x: 0, y: 20 },
  // TopRight
  { x: 35, y: 20 },
  // BottomRight
  { x: 22, y: 83 },
  // BottomLeft
  { x: -5, y: 79 },
];

// Default settings for centrally located drivers' field-of-view non-repairable area
// Distances measured in % from windshield segment's top edge center point
const DEFAULT_DRIVER_FOV_CENTER = [
  // TopLeft
  { x: -16, y: 20 },
  // TopRight
  { x: 16, y: 20 },
  // BottomRight
  { x: 12, y: 81 },
  // BottomLeft
  { x: -12, y: 81 },
];

const REPAIRABILITY_REVIEW_TRIGGER_TYPE = {
  DIFFERENT_DAMAGE_TYPES: 0,
  NO_DAMAGE_CHECK: 1,
  CHIP_SEGMENT_IN_NON_REPAIRABLE_AREA: 2,
  WINDSHIELD_IN_WRONG_POSE: 3,
  MAXIMUM_REPAIRABLE_DAMAGES_EXCEEDED: 4,
  BOTH_CLOSE_UP_IMAGES_BLURRY: 5,
  USER_MARKED_DAMAGES_ARE_OVERLAPPING: 6,
  UNCERTAIN_REPAIR_DECISION: 7
};

const REPAIRABILITY_REVIEW_TRIGGER_TYPE_NAME = {
  [REPAIRABILITY_REVIEW_TRIGGER_TYPE.DIFFERENT_DAMAGE_TYPES]: 'Different damage types',
  [REPAIRABILITY_REVIEW_TRIGGER_TYPE.NO_DAMAGE_CHECK]: 'No damage check',
  [REPAIRABILITY_REVIEW_TRIGGER_TYPE.CHIP_SEGMENT_IN_NON_REPAIRABLE_AREA]: 'Chip segment in non & repairable area',
  [REPAIRABILITY_REVIEW_TRIGGER_TYPE.WINDSHIELD_IN_WRONG_POSE]: 'Windshield in wrong pose',
  [REPAIRABILITY_REVIEW_TRIGGER_TYPE.MAXIMUM_REPAIRABLE_DAMAGES_EXCEEDED]: 'Maximum repairable damages exceeded',
  [REPAIRABILITY_REVIEW_TRIGGER_TYPE.BOTH_CLOSE_UP_IMAGES_BLURRY]: 'Both close-up images blurry',
  [REPAIRABILITY_REVIEW_TRIGGER_TYPE.USER_MARKED_DAMAGES_ARE_OVERLAPPING]: 'User marked damages overlapping',
  [REPAIRABILITY_REVIEW_TRIGGER_TYPE.UNCERTAIN_REPAIR_DECISION]: 'AI decision is "Uncertain"'
};

const REPAIRABILITY_REVIEW_TRIGGER_DESCRIPTION = {
  [REPAIRABILITY_REVIEW_TRIGGER_TYPE.DIFFERENT_DAMAGE_TYPES]: 'Closeup damages of the same damage are different type',
  [REPAIRABILITY_REVIEW_TRIGGER_TYPE.NO_DAMAGE_CHECK]: 'Both closeups were detected as “no-damage”',
  [REPAIRABILITY_REVIEW_TRIGGER_TYPE.CHIP_SEGMENT_IN_NON_REPAIRABLE_AREA]: 'Damage marked by user was in non-repair and repair area',
  [REPAIRABILITY_REVIEW_TRIGGER_TYPE.WINDSHIELD_IN_WRONG_POSE]: 'Windshield in wrong pose',
  [REPAIRABILITY_REVIEW_TRIGGER_TYPE.MAXIMUM_REPAIRABLE_DAMAGES_EXCEEDED]: 'Maximum repairable damages exceeded',
  [REPAIRABILITY_REVIEW_TRIGGER_TYPE.BOTH_CLOSE_UP_IMAGES_BLURRY]: 'Both close-up images are blurry',
  [REPAIRABILITY_REVIEW_TRIGGER_TYPE.USER_MARKED_DAMAGES_ARE_OVERLAPPING]: 'User marked damages are overlapping',
  [REPAIRABILITY_REVIEW_TRIGGER_TYPE.UNCERTAIN_REPAIR_DECISION]: 'Uncertain repair decision'
};

export default {
  NAME,
  DRIVER_FIELD_OF_VIEW,
  DRIVER_FIELD_OF_VIEW_NAME,
  DRIVER_FIELD_OF_VIEW_LOCATION,
  DRIVER_FIELD_OF_VIEW_LOCATION_NAME,
  DEFAULT_ADAS_FOV,
  DEFAULT_DRIVER_FOV_LEFT,
  DEFAULT_DRIVER_FOV_RIGHT,
  DEFAULT_DRIVER_FOV_CENTER,
  REPAIRABILITY_REVIEW_TRIGGER_TYPE,
  REPAIRABILITY_REVIEW_TRIGGER_TYPE_NAME,
  REPAIRABILITY_REVIEW_TRIGGER_DESCRIPTION
};
